/**
 * Language Selector Button.
 * @format
 */
/* eslint-disable max-len */

import React, { useContext } from 'react';
import { NavigationContext } from '@context/navigation-context';
import { useStateValue } from '@context/state-context';
import {
  LocaleLanguage,
  NavigationData,
} from '@context/navigation-context-modals';
import {
  getCurrentLanguage,
  CurrentLanguageProps,
} from './language-selector-utils';

/**
 * Language Selector Button.
 * @returns
 */
const LanguageSelectorButton = (): JSX.Element => {
  const navigationData: NavigationData = useContext(NavigationContext);
  const { locale_languages: localeLanguages }: LocaleLanguage = navigationData;
  const currentLanguage = getCurrentLanguage(localeLanguages);
  const { language, flag }: CurrentLanguageProps = currentLanguage;
  const [{ updateToggle, openToggle }, dispatch] = useStateValue();
  const languageCode = window.drupalSettings?.path?.currentLanguage;

  /**
   * Toggle Menu.
   *
   * @param {boolean} open
   * @param {boolean} close
   */
  const toggleMenu = (open: boolean, close: boolean) => {
    dispatch({
      type: 'toggleMenu',
      toggleOpen: { menuOpen: open, closing: close },
    });
  };

  /**
   * Toggle Language Selector.
   */
  const toggleLanguageSelector = (
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ) => {
    event.preventDefault();
    dispatch({
      type: 'toggleLocale',
      updateLocale: {
        localeOpen: !updateToggle.localeOpen,
      },
    });
    if (openToggle.menuOpen) {
      toggleMenu(false, true);
      setTimeout(() => {
        toggleMenu(false, false);
      }, 300);
    }
  };

  /**
   * Render.
   */
  return (
    <button
      className="language-select-button"
      onClick={(event) => toggleLanguageSelector(event)}>
      <img
        src={`/themes/custom/varian/webpack/scripts/components/language-selector/images/flags/${flag}.png`}
        alt=""
      />{' '}
      <span data-language-code={languageCode ? languageCode.toUpperCase() : ''}>
        {language}
      </span>
    </button>
  );
};
export default LanguageSelectorButton;
